<style scoped>
.expand-row {
  margin-bottom: 16px;
}
</style>
<template>
  <div>
    <Row class="expand-row">
      <Table :columns="columns8" :data="row.rows"> </Table>
    </Row>
    <Modal
      v-model="laiyuantishi"
      title="提醒"
      @on-ok="quedinglaiyuan"
      @on-cancel="laiyuantishi = false"
    >
      <p>{{ laiyuantitle }}</p>
    </Modal>

    <Modal
      v-model="caidanmodal"
      title="提醒"
      @on-ok="caidanok"
      @on-cancel="caidanmodal = false"
    >
      <p>确定拆成独立订单吗?</p>
    </Modal>
    <Modal
      v-model="updateSource"
      title="修改商品来源"
      @on-ok="updateSourceModalOk"
      @on-cancel="updateSource = false"
    >
      <Select v-model="selectedSource" placeholder="请选择商品来源">
        <Option
          v-for="item in goodsource"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </Option>
      </Select>
    </Modal>
    <Modal
      v-model="costModal"
      title="修改商品成本"
      @on-ok="updateCost"
      @on-cancel="costModal = false"
    >
      <Input v-model="newCost" placeholder="请输入新的成本价"  />
    </Modal>
  </div>
</template>
<script>
import { cmsChaiOrder, cmsCaigouOrder, cmsUpdateSource,cmsUpdateCost } from "../../api/fahuo";
const GOODS_SOURCE = [
  { value: "本地库", label: "本地库" },
  { value: "上海青柠", label: "上海青柠" },
  { value: "洛克科技", label: "洛克科技" },
  { value: "品胜电器", label: "品胜电器" },
  { value: "京东平台", label: "京东平台" },
  { value: "淘宝平台", label: "淘宝平台" },
  { value: "giso潮玩", label: "giso潮玩" },
  { value: "zigo咖啡", label: "zigo咖啡" },
  { value: "伯希和露营", label: "伯希和露营" },
  { value: "心心潮玩", label: "心心潮玩" },
  { value: "乐高积木", label: "乐高积木" },
  { value: "万事屋", label: "万事屋" },
];
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      goodsource: GOODS_SOURCE,
      laiyuantitle: "",
      selectedSource: "", // 选中的商品来源
      datanum: this.row.rows,
      laiyuantishi: false,
      caidanmodal: false,
      updateSource: false,
      costModal: false,
      newCost: "",
      currentGoodsId: null,
      selrow: {},
    };
  },
  computed: {
    columns8() {
      const baseColumns = [
        {
          title: "商品id",
          key: "goodsid",
        },
        {
          title: "商品名称",
          key: "goodsname",
        },
        {
          title: "商品图片",
          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: process.env.OSS  + params.row.goodsimg,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },
        },
        {
          title: "商品数量",
          key: "goodsnum",
        },
        {
          title: "商品成本",
          key: "cost",
          render: (h, params) => {
            const cost = params.row.cost;
            const goodsnum = params.row.goodsnum;
            return h("span", cost * parseInt(goodsnum));
          },
        },
        {
          title: "商品类型",
          key: "goodstype",
        },
        {
          title: "商品来源",
          key: "goodssource",
        },
        {
          title: "采购状态",
          key: "procurestatus",
          render: (h, params) => {
            const procurestatus = params.row.procurestatus;
            return h("span", procurestatus === 0 ? "未采购" : "已采购");
          },
        },
      ];

      // 如果 ordetype 不是 1 或 4，则添加操作列
      if (
        this.row.rows[0].ordertype !== 1 &&
        this.row.rows[0].ordertype !== 4
      ) {
        baseColumns.push({
          title: "操作",
          key: "action",
          width: 300,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.$emit("triggerReturnOrder", [params.row]);
                    },
                  },
                },
                "退回"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.costModal = true;
                      this.currentGoodsId = params.row.goodsid;
                      this.newCost = params.row.cost;
                      this.selrow = params.row;
                    },
                  },
                },
                "修改成本"
              ),
              parseInt(params.row.procurestatus) == 0
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.selrow = params.row;
                          this.caigouok();
                        },
                      },
                    },
                    "已采购"
                  )
                : null, // 不满足
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.selrow = params.row;
                      this.updateSource = true; // 弹出修改来源弹窗
                      this.selectedSource = ""; // 清空之前的选择
                    },
                  },
                },
                "修改来源"
              ),
              this.row.rows.length > 1 || parseInt(params.row.goodsnum) > 1
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.selrow = params.row;
                          this.caidanmodal = true;
                        },
                      },
                    },
                    "拆单"
                  )
                : null, // 不满足
            ]);
          },
        });
      }

      return baseColumns;
    },
  },
  methods: {
    caidanok() {
      this.selrow.rownum = this.row.rows.length;
      cmsChaiOrder(this.selrow).then((res) => {
        console.log(res);
        this.$emit("triggerQueryGoods"); // 发送事件给父组件
      });
      this.caidanmodal = false;
    },
    caigouok() {
      cmsCaigouOrder(this.selrow).then((res) => {
        console.log(res);
        this.selrow.procurestatus = 1;
      });
    },
    updateSourceModalOk() {
      if (!this.selectedSource) {
        this.$Message.error("请选择商品来源");
        return;
      }
      if (this.selectedSource == this.selrow.goodssource) {
        this.$Message.warning("商品来源未修改");
        return;
      }
      if (
        this.selectedSource != "本地库" &&
        this.selrow.goodssource == "本地库"
      ) {
        this.laiyuantitle =
          "本地库修改为代发,当前商品将退回至库存,库存数量将增加";
        this.updateSource = false;
        this.laiyuantishi = true;
        return;
      }

      if (
        this.selrow.goodssource != "本地库" &&
        this.selectedSource == "本地库"
      ) {
        this.laiyuantitle =
          "要将代发转换成本地库,当前商品将扣库存,库存数量将减少";
        this.updateSource = false;
        this.laiyuantishi = true;
        return;
      }

      cmsUpdateSource({
        goodsid: this.selrow.goodsid,
        goodsnum: this.selrow.goodsnum,
        orderid: this.selrow.orderid,
        oldsource: this.selrow.goodssource,
        source: this.selectedSource,
        id: this.selrow.id,
      }).then((res) => {
        this.selrow.goodssource = this.selectedSource;
      });
    },
    quedinglaiyuan() {
      this.laiyuantishi = false;
      cmsUpdateSource({
        goodsid: this.selrow.goodsid,
        goodsnum: this.selrow.goodsnum,
        orderid: this.selrow.orderid,
        oldsource: this.selrow.goodssource,
        source: this.selectedSource,
        id: this.selrow.id,
      }).then((res) => {
        this.selrow.goodssource = this.selectedSource;
      });
    },
    async updateCost() {
      if (!this.newCost) {
        this.$Message.error("请输入成本价");
        return;
      }
      try {
        
        cmsUpdateCost({
          orderid: this.selrow.id,
          cost: this.newCost
      }).then((res) => {
        const index = this.row.rows.findIndex(item => item.goodsid === this.currentGoodsId);
       });
      } catch (error) {
        this.$Message.error("修改失败：" + error.message);
      }
    },
  },
};
</script>
